import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IResponse } from "@bt/shared";
import { map } from "rxjs/operators";

import { ApiService } from "./api.service";
import { Observable } from 'rxjs';
import { promise } from 'protractor';
import { Router } from "@angular/router";
import { AuthService } from './auth.service';
import { ChangePasswordByAdmin,
         AdminInviteModel, UsersInviteModel,
         PasswordConfirmModel,UserModel,UserFilterModel } from '@bt/core/models';
import { GetSessionModel } from '../models/getSession.model';
import { SessionFilter } from '../models/sessionFilter.model';


@Injectable()
export class UserService {
  public user = new BehaviorSubject<UserModel>(new UserModel());
  public userChanges = this.user.asObservable();

  public currentUser: UserModel = null;
  public isSession: boolean;

  constructor(private api: ApiService, 
              private router: Router,
              private authService: AuthService) { }

  //////////////////////////////////////////////////////
  //   public init() {
  //     var obs: Observable<any>;

  //     if (this.get() == undefined || this.get() == null) {
  //       obs = this.refresh();
  //     } else {
  //       obs = Observable.of(this.get());
  //     }
  //     return obs;
  //   }

  //   public get() {
  //     return this.currentUser;
  //   }

  //   public refresh(): Observable<IResponse<UserModel>> {
  //     var obs: Observable<any>;

  //     this.api.get<UserModel>('api/users/me').toPromise()
  //         .then(resp => {
  //             this.currentUser = resp.data;
  //             obs = Observable.of(this.currentUser);
  //         })
  //         .catch(e => {
  //             // localStorage.removeItem("access_token");
  //             // me.eraseCookie("access_token");
  //             // me.$state.go('login');
  //         })

  //     return obs;
  // }
  //////////////////////////////////////////////////////

  public logout() {
    
    this.currentUser = null;
    this.authService.logout();
    this.isSession = false;
}

public clearAuth(){
  this.currentUser = null;
  this.authService.clearAuth();
}
  public updateUser = () => {
    this.loadUser().forEach((data: UserModel) => this.user.next(data));
  }

  public loadUser = () => {
    return this.api.get("api/course/me").pipe(map(z => z.data));
  }

  get userData(): UserModel {
    return this.user.value;
  }

  public getMe() {
    var t = this;

    this.api.get<UserModel>("api/course/me").toPromise()
      .then(resp => {
        t.currentUser = resp.data;
      });
  }

  public editUserInfo(editModel: UserModel): Promise<IResponse<UserModel>> {
    return this.api.put<UserModel>("api/users/edit", editModel).toPromise();
  }

  public editUserInfoByAdmin(editModel: UserModel): Promise<IResponse<UserModel>> {
    return this.api.put<UserModel>("api/users/editbyadmin", editModel).toPromise();
  }
  
  public getAllUsers(filter: UserFilterModel): Promise<IResponse<UserModel[]>> {
    return this.api.put<UserModel[]>("api/users/getAllUsers", filter).toPromise();
  }
  //получение кол- ва пользователей
  public getAllNumberOfUsers(): Promise<IResponse<number[]>> {
    return this.api.get<number[]>("api/users/getAllNumUsers").toPromise();
  }
  public getAllNumberOfUsersForSuperAdmin(): Promise<IResponse<number[]>> {
    return this.api.get<number[]>("api/users/getAllNumberOfUsersForSuperAdmin").toPromise();
  }


  public deleteUsers(usersList: UserModel[]): Promise<IResponse<boolean>> {
    return this.api.put<boolean>("api/users/deleteUsers", usersList).toPromise();
  }

  public changePasswordByAdmin(model: ChangePasswordByAdmin): Promise<IResponse<boolean>> {
    return this.api.put<boolean>("api/users/changePasswordByAdmin", model).toPromise();
  }
  
  public setUserStatus(userId: string, newStatus: number): Promise<IResponse<boolean>> {
    return this.api.put<boolean>("api/users/setUserStatus", {
      userId: userId,
      newStatus: newStatus
    }).toPromise();
  }

  public createUsers(usersInviteModel: UsersInviteModel): Promise<IResponse<boolean>> {
    return this.api.post<boolean>("api/users/createUsers", usersInviteModel).toPromise();
  }

  public createAdmin(adminInviteModel: AdminInviteModel): Promise<IResponse<boolean>> {
    return this.api.post<boolean>("api/users/createAdmin", adminInviteModel).toPromise();
  }

  public reset(): void {
    this.user.next(new UserModel());
  }

  public setPassword(passwordConf: PasswordConfirmModel): Observable<IResponse<boolean>> {
    return this.api.putAnonym<boolean>("api/users/restore", passwordConf);
  }

  public editPassword(newPassword: any): Promise<IResponse<boolean>> {
    return this.api.put<boolean>("api/users/editPassword", newPassword).toPromise();
  }

  public getRole(): number {
    if (this.currentUser != null)
      return this.currentUser.role;
    else
      return null;
  }
  public getStatus(): number {
    if (this.currentUser != null) {
      return this.currentUser.status;
    }
    else
      return null;
  }

  public getId(): string {
    if (this.currentUser != null) {
      return this.currentUser.id;
    }
    else
      return null;
  }

  public getAccessKeys(): string[] {
    if (this.currentUser != null) 
      return this.currentUser.accessKeys;
    else
      return null;
  }
  public saveSession(): Promise<IResponse<boolean>> {
    return this.api.get<boolean>("api/users/saveSession").toPromise();
  }

  public getSessions(sessionFilter: SessionFilter): Promise<IResponse<GetSessionModel[]>> {
    return this.api.put<GetSessionModel[]>("api/users/getSessions",sessionFilter).toPromise();
  }

  

}



// WEBPACK FOOTER //
// ./src/app/core/services/user.service.ts